// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tRDa","type":"styles_type__2PDng","choices":"styles_choices__3D63S"};